import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { DoorOpen, Users, Presentation, ClipboardCheck, Wine } from "lucide-react";
import { PROGRAM } from "@/lib/siteData";

const ICONS = { DoorOpen, Users, Presentation, ClipboardCheck, Wine };

export const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 65%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="programm" className="relative overflow-hidden bg-ink px-4 sm:px-6 py-28 sm:py-36" data-testid="timeline-section">
      <div className="pointer-events-none absolute right-[-8%] top-1/3 h-[420px] w-[420px] rounded-full bg-violet/15 blur-[130px]" />

      <div className="relative z-10 mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 max-w-2xl"
        >
          <p className="mb-5 text-xs uppercase tracking-[0.35em] text-cyan">Programm des Abends</p>
          <h2 className="font-display text-4xl sm:text-6xl tracking-tight text-ivory leading-[1.02]">
            Ein Abend, der <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-cyan via-violet to-magenta">bewegt</span>.
          </h2>
        </motion.div>

        <div ref={ref} className="relative pl-16 sm:pl-24">
          {/* Rail */}
          <div className="absolute left-[26px] sm:left-[38px] top-2 bottom-2 w-px bg-white/10" />
          <motion.div
            style={{ scaleY }}
            className="absolute left-[26px] sm:left-[38px] top-2 bottom-2 w-px origin-top bg-gradient-to-b from-cyan via-violet to-magenta"
          />

          <div className="space-y-12 sm:space-y-16">
            {PROGRAM.map((item, i) => {
              const Icon = ICONS[item.icon];
              return (
                <motion.div
                  key={item.time}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                  className="relative flex items-center gap-6 sm:gap-8"
                  data-testid={`timeline-item-${item.time.replace(":", "")}`}
                >
                  {/* Node */}
                  <span className="absolute -left-16 sm:-left-24 flex h-[54px] w-[54px] sm:h-[78px] sm:w-[78px] items-center justify-center rounded-full border border-white/10 bg-ink">
                    <span className="flex h-full w-full items-center justify-center rounded-full bg-white/[0.04] text-cyan">
                      <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
                    </span>
                  </span>

                  <div className="flex flex-col sm:flex-row sm:items-baseline sm:gap-6">
                    <span className="font-display text-3xl sm:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-cyan to-violet tabular-nums">
                      {item.time}
                    </span>
                    <span className="font-display text-2xl sm:text-3xl text-ivory">{item.title}</span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
